import React from "react";
import { TableShimmerProps } from "./utils/types";

const TableShimmer: React.FC<TableShimmerProps> = ({ rowCount = 7 }) => {

  return (
    <div className="w-full border border-border-gray dark:border-border-gray-dk rounded-lg overflow-hidden">
      <div className="border-b border-border-gray dark:border-border-gray-dk">
        <div className="px-[12px] py-2 h-[60px]">
          <div className="h-full w-full bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse" />
        </div>
      </div>

      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          className="border-b border-border-gray dark:border-border-gray-dk"
        >
          <div className="px-[12px] py-2 h-[60px]">
            <div className="h-full w-full bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default TableShimmer;
